import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserIsIdentified } from 'core/selectors/user';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectSiteUrl } from 'core/selectors/app';
import { useCheckIsCardHolder } from 'org/hooks/useCheckIsCardHolder';

function ToggleBanner() {
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const siteUrl = useSelector(selectSiteUrl);
  const isCardHolder = useCheckIsCardHolder();

  const [isExpanded, setIsExpanded] = useState(false);

  const toogleView = () => setIsExpanded(!isExpanded);

  const getCollapsedTitle = () => {
    if (!userIsIdentified) {
      return <>Plus, NEW MEMBERS EARN UP TO 1,000 Bonus miles</>;
    }
    return <>New Members: earn {isCardHolder ? '1000' : '500'} bonus miles</>;
  };

  const getExpandedTitle = () => {
    if (!userIsIdentified) {
      return <>Earn up to 1,000 bonus miles</>;
    }
    return <>Earn {isCardHolder ? '1000' : '500'} bonus miles</>;
  };

  const getExpandedPreTitle = () => {
    if (!userIsIdentified) {
      return <>NEW MEMBER Bonus</>;
    }

    return isCardHolder
      ? <>UNITED MILEAGEPLUS<sup>&reg;</sup> CREDIT CARD HOLDERS</>
      : <>UNITED MILEAGEPLUS<sup>&reg;</sup> Members</>;
  };

  const collapsedTitle = getCollapsedTitle();
  const expandedTitle = getExpandedTitle();
  const expandedPreTitle = getExpandedPreTitle();

  const renderExpandedView = () => (
    <div className="mn_bannerData">
      <div className="mn_preHeader">{expandedPreTitle}</div>
      <h3>{expandedTitle}</h3>
      <p>When you spend $25 in the next two weeks.</p>
      <a href={`${siteUrl}/signin`}>Learn more</a>
    </div>
  );

  const renderCollapsedView = () => (
    <div className="mn_bannerData">
      <h3>{collapsedTitle}</h3>
    </div>
  );

  return (
    <div className={`mn_acquisitionBonusBanner mn_toggleBanner ${isExpanded ? 'mn_expanded' : 'mn_collapsed'}`}>
      {isExpanded ? renderExpandedView() : renderCollapsedView()}
      <button
        className={`mn_toggle ${isExpanded ? 'mn_closeButton' : 'mn_openButton'}`}
        onClick={toogleView}
        aria-label={`${isExpanded ? 'collapse' : 'expand'} section`}
      />
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><ToggleBanner {...props} /></ComponentErrorBoundary>;
